import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';

@Injectable()
export class AdminguardGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthenticationService, private router: Router) {}

  // Used for parent routes if needed
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.checkAccess(next, state);
  }

  // Used for all child routes
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.checkAccess(childRoute, state);
  }

  private checkAccess(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.authService.userdata || JSON.parse(localStorage.getItem('user') || 'null');

    // Not logged in
    if (!user || !this.authService.loggedIn()) {
      this.router.navigate(['admin']);
      return false;
    }

    // Super admin can access everything
    if (user.role === 'super_admin') {
      return true;
    }

    // Check menu access for the route
    const requiredMenu = route.data['menu'];
    if (!requiredMenu) {
      return true; // no restriction
    }

    if (Array.isArray(user.menu) && user.menu.includes(requiredMenu)) {
      return true;
    }

    // ❌ Not allowed → redirect to dashboard or first allowed menu
    const fallback = user.menu.includes('Dashboard') ? '/admin/dashboard' : '/admin';
    this.router.navigate([fallback]);
    return false;
  }
}
